import { useContext } from 'react';
import { css, cx } from '@eti/styles';
import { RadioGroupContext } from '../radio_group/RadioGroup';
import RadioButton from '../radio_button/RadioButton';
import { jsx as _jsx } from "react/jsx-runtime";
const labelStyles = css`
  align-items: normal;
  display: inline-block;
  font-weight: 400;
  padding-left: 1.875rem;

  html[dir='rtl'] & {
    left: auto;
    padding-left: 0;
    padding-right: 1.875rem;
    right: 0;
  }

  @media (min-width: 60.625em) {
    padding-left: 1.8125rem;

    html[dir='rtl'] & {
      padding-left: 0;
      padding-right: 1.8125rem;
    }
  }
`;
const customRadioStyles = css`
  position: absolute;
`;
const EtiRadio = ({
  className,
  children,
  id,
  isNeutral,
  dataTestId,
  value,
  ...rest
}) => {
  const context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error('EtiRadio must be used within a RadioGroup');
  }
  const {
    name,
    selectedValue,
    onChange
  } = context.radioGroup;
  const handleOnchange = () => {
    if (value !== undefined) {
      onChange === null || onChange === void 0 || onChange(value);
    }
  };
  const areValuesEqual = () => {
    if (Array.isArray(value) && Array.isArray(selectedValue)) {
      return JSON.stringify(value) === JSON.stringify(selectedValue);
    }
    return selectedValue !== undefined ? value === selectedValue : selectedValue;
  };
  return /*#__PURE__*/_jsx(RadioButton, {
    classNames: {
      label: cx(labelStyles, className),
      radio: customRadioStyles
    },
    id: id,
    isNeutral: isNeutral,
    isSelected: areValuesEqual(),
    labelTestId: dataTestId,
    name: name,
    onChange: handleOnchange,
    value: value,
    ...rest,
    children: children
  });
};
export default EtiRadio;
//# sourceMappingURL=Radio.js.map